import cn from 'classnames';
import React from 'react';
import './input.sass';

interface IProps {
  label: string | JSX.Element;
  name: string;
  value: string;
  onChange: (e: any) => void;
  className?: string;
  placeholder?: string;
  type?: string;
  multiline?: boolean;
  error?: string;
  disabled?: boolean;
}

const Input = React.forwardRef<any, IProps>(
  ({className, type = 'text', multiline, error, label, placeholder, ...inputProps}, ref) => {
    const props = {
      className: cn('input__input', {
        _multiline: multiline,
        _disabled: inputProps.disabled,
        _error: !!error,
        '_has-value': !!inputProps.value,
      }),
      placeholder: placeholder,
      ...inputProps,
    };
    return (
      <div className={cn('input', className)}>
        <div className="input__inner">
          <div
            className={cn('input__label', {
              '_has-value': !!inputProps.value,
            })}
          >
            {label}
          </div>
          {multiline ? <textarea {...props} ref={ref} /> : <input type={type} {...props} ref={ref} />}
          {error ? <div className="input__error">{error}</div> : null}
        </div>
      </div>
    );
  },
);

export default Input;
